/**
 * Session timestamps. A session has three different "whens" and showing the
 * wrong one is confusing: a session booked on Monday but held on Wednesday
 * must read Wednesday. Order of truth: scheduled slot (while still scheduled)
 * → when it was held → when it was created.
 */
export function sessionMoment(meeting) {
  if (!meeting) return { label: "", iso: null };
  if (meeting.status === "scheduled" && meeting.scheduled_for) {
    return { label: "Scheduled", iso: meeting.scheduled_for };
  }
  if (meeting.completed_at) return { label: "Held", iso: meeting.completed_at };
  if (meeting.status === "active") return { label: "Started", iso: meeting.created_at };
  return { label: "Created", iso: meeting.created_at };
}

/** Local date + time, no seconds (e.g. "8/13/2026, 8:30 PM"). */
export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    year: "numeric", month: "numeric", day: "numeric",
    hour: "numeric", minute: "2-digit",
  });
}

/** Local long date (e.g. "Thursday, 13 August 2026"). */
export function fmtLongDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });
}

/** Sort key: the moment a session actually happened (or is due to). */
export function sessionSortTime(meeting) {
  const { iso } = sessionMoment(meeting);
  return new Date(iso || 0).getTime();
}

/**
 * Lateness. A session held more than a day after its booked slot is "late" —
 * quiet signal only, so the pattern shows up over a quarter without nagging.
 */
export function sessionLateness(meeting) {
  if (!meeting || meeting.status !== "completed") return null;
  if (!meeting.scheduled_for || !meeting.completed_at) return null;
  const slot = new Date(meeting.scheduled_for).getTime();
  const held = new Date(meeting.completed_at).getTime();
  if (Number.isNaN(slot) || Number.isNaN(held)) return null;
  const days = Math.floor((held - slot) / 86400000);
  return days >= 1 ? { days, label: `${days}d late` } : null;
}
